var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"1000px","src":_vm.url,"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }